import { c as _c } from "react/compiler-runtime";
import { LayoutCenter } from 'design-system/server';
import { useTranslations } from 'next-intl';
import styles from './SimpleFooter.module.css';
function SimpleFooter() {
  const $ = _c(4);
  const t = useTranslations("nextjs.core");
  let t0;
  if ($[0] !== t) {
    t0 = t("provider_info");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <footer className={styles.container}><LayoutCenter centeredChildren={true}>{t0}</LayoutCenter></footer>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default SimpleFooter;